export default __webpack_public_path__ + "static/media/services_01.308be987.jpg";